import { render, staticRenderFns } from "./TreatmentCategory.vue?vue&type=template&id=6d2960dd&"
import script from "./TreatmentCategory.vue?vue&type=script&lang=js&"
export * from "./TreatmentCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports